import React from 'react';

import styles from './AssetCartRequest.module.scss';

interface ICollapsibleLabelProps {
	label: string;
}

const CollapsibleLabel = ({ label }: ICollapsibleLabelProps) => (
	<div className={styles.collapsibleLabel}>
		{label}
	</div>
);

export default CollapsibleLabel;
